module.exports = {
	"header.logo.title": "Configuratore GROHE SmartControl.",
	"homepage.headline": "Configuratore GROHE SmartControl",
	"homepage.introtext": "Rispondi alle domande che seguono per configurare il sistema doccia GROHE SmartControl adatto alle tue esigenze.",
	"homepage.buttonStart": "Inizio",
	"homepage.buttonStartTracking": "showersystem-configurator/start",
	"footer.privacy.text": "Privacy",
	"footer.privacy.url": "https://www.grohe.ch/it_ch/azienda/privacy.html",
	"footer.disclaimer.text": "Legal Info",
	"footer.disclaimer.url": "https://www.grohe.ch/it_ch/azienda/note-legali.html",
	"footer.copyright": "&copy; 2018 GROHE Switzerland SA",
	"configurator.button.seeResults": "Guarda i risultati",
	"question1.question": "Per quale zona del bagno hai bisogno del configuratore doccia?",
	"question1.option1.text": "Per la mia zona doccia",
	"question1.option2.text": "Per la mia zona vasca",
	"question2.question": "Che tipo di installazione preferisci? Esterna, ad incasso o una combinazione delle due?",
	"question2.option1.text": "Esterna: soluzione semplice e veloce di fronte al muro",
	"question2.option2.text": "Combinazione: tubazioni nascoste dietro al muro e termostatico esterno con mensola portasapone di fronte al muro",
	"question2.option3.text": "Incasso: look pulito e minimale con tutta la tecnologia nascosta dietro al muro",
	"question3.question": "Come vorresti azionare la tua doccia?",
	"question3.option1.text": "Con un azionamento ed un controllo facile (SmartControl) e un miscelatore termostatico",
	"question3.option2.text": "Con un azionamento tradizionale ed un miscelatore termostatico",
	"question3.option3.text": "Con un miscelatore monocomando",
	"question3.option4.text": "Con un sistema con deviatore (per mantenere l'attuale miscelatore)",
	"question4.question": "Cosa vorresti poter gestire con la tua doccia?",
	"question4.option1.text": "Solo una manopola doccia",
	"question4.option2.text": "Un soffione grande (150-250mm) e una manopola doccia",
	"question4.option3.text": "Un soffione extra large (250-400mm) e una manopola doccia",
	"question4.option4.text": "Un soffione grande (150-250mm), una manopola doccia e una bocca vasca",
	"question4.option5.text": "Un soffione extra large (250-400mm), una manopola doccia e una bocca vasca",
	"question5.question": "Che forma preferisci?",
	"question5.option1.text": "Squadrata",
	"question5.option2.text": "Tonda",
	"question6.question": "Cosa vorresti poter gestire con la tua nuova doccia SmartControl?",
	"question6.option1.text": "Un soffione a due getti e una manopola doccia",
	"question6.option2.text": "Un soffione a due getti e una manopola doccia",
	"question6.option3.text": "Un soffione, una manopola doccia e una bocca vasca",
	"question6.option4.text": "Un soffione, due getti laterali e una manopola doccia",
	"question6.option5.text": "Un soffione e una manopola doccia",
	"question6.option6.text": "Una manopola doccia e una bocca vasca",
	"question6.option7.text": "Solo una manopola doccia",
	"question6.option8.text": "Solo una bocca vasca",
	"question7.question": "Scegli il colore",
	"question7.option1.text": "Cromo",
	"question7.option2.text": "Bianco/Cromo",
	"question7.option3.text": "Bianco/Cromo",
	"question8.question": "Vuoi un miscelatore termostatico con il supporto per la manopola doccia incluso?",
	"question8.option1.text": "No, acquisterò un supporto per la manopola doccia separatamente",
	"question8.option2.text": "Sì, con un supporto per la manopola doccia integrato",
	"question9.question": "Come vorresti  fosse tenuta la tua manopola doccia?",
	"question9.option1.text": "Da un'asta doccia con un supporto per manopola doccia regolabile",
	"question9.option2.text": "Da un suppporto minimal",
	"question10.question": "Vuoi installare il tuo soffione alla parete o al soffitto?",
	"question10.option1.text": "A parete",
	"question10.option2.text": "A soffitto",
	"results.title": "Your {productGroupsCount, plural, \none {Result} \nother {Results}\n}",
	"results.proposal.title": "Proposal {number}",
	"results.proposal.title.single": "Proposal",
	"results.bundle.title": "Per una corretta installazione avrai bisogno anche di:",
	"results.newConfiguration.title": "Do you want to configurate a new shower system?",
	"results.newConfiguration.buttonText": "Inizia una nuova configurazione",
	"results.product.number": "Codice articolo: #{number}",
	"results.product.button.productInformation": "Informazione di prodotto",
	"results.product.button.dealerLocator": "Trova uno showroom",
	"results.product.button.buyNow": "Buy now",
	"results.product.button.downloadPDF": "Download PDF",
	"results.product.information": "Product Information",
	"results.product.dealer": "Trova uno showroom",
	"hatchModal.title": "Buy online",
	"hatchModal.btnText": "Buy Online",
	"hatchModal.stockInfo": "{stockQuantity, plural, \nzero {Not on Stock} \nother {On Stock}\n}",
	"hatchModal.buyNow": "Buy Now",
	"404.title": "Erreur page 404",
	"404.link.goBack": "Retour à la page d’accueil"
};


//////////////////
// WEBPACK FOOTER
// ./src/translations/shower.it_ch.json
// module id = 759
// module chunks = 0